import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: black;
`;

export const FooterWrap = styled.div`
  padding: 88px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;

  @media screen and (max-width: 480px) {
    padding: 64px 16px;
  }
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px;
  text-align: center;
  width: 160px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 14px;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;
  transition: color 0.2s ease;

  &:hover {
    color: #01bf71;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  max-width: 1100px;
  margin: 40px auto 0 auto;

  gap: 16px;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    text-align: center;
  }
`;

/* ✅ LOGO cliquable (conteneur) */
export const SocialLogo = styled(Link)`
  justify-self: start;
  cursor: pointer;
  text-decoration: none;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 16px;
  padding: 6px 10px;

  border-radius: 14px;
  transition: background 0.2s ease, transform 0.12s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  &:active {
    transform: scale(0.98);
  }

  @media screen and (max-width: 820px) {
    margin-bottom: 10px;
  }
`;

/* ✅ IMAGE du logo */
export const SocialLogoImg = styled.img`
  height: 110px;
  width: auto;
  display: block;
  object-fit: contain;

  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.35));

  @media screen and (max-width: 820px) {
    height: 102px;
  }

  @media screen and (max-width: 480px) {
    height: 108px;
  }
`;

export const WebsiteRights = styled.small`
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 16px;
  font-size: 12px;
  line-height: 1.35;

  @media screen and (max-width: 820px) {
    margin-bottom: 10px;
    max-width: 340px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;

  @media screen and (max-width: 480px) {
    width: 200px;
  }
`;

export const SocialIconLink = styled.a`
  color: rgba(255, 255, 255, 0.92);
  font-size: 24px;
  transition: transform 0.12s ease, color 0.2s ease;

  &:hover {
    color: #01bf71;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }
`;